<template lang="pug">
  #home.h-100
    router-view
</template>

<script>

export default {
  name: 'Home'
};
</script>
